export function noop() {}
/**
 * Return f if it is a function, otherwise return a noop.
 *
 * @param {any} f the var to test
 * @return {function} f iff is a function, otherwise an empty noop function
 */
export default function(f) {
  return typeof f === 'function' ? f : noop;
}
